// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2B_fI","inner":"style_inner__t-xso","titleholder":"style_titleholder__3MrTP","title":"style_title__1oBfb"};